import React from "react";
import * as ROUTES from '../../../routes';


function AditionalInfo(props) {
  return (
    <div className="AditionalInfo">
      <p className="AditionalInfo_title">Información Adicional</p>
      <a className="AditionalInfo_link" href={`${ROUTES.ADDITIONAL_INFO}terminos-y-condiciones`}>Términos y condiciones</a>
      <a className="AditionalInfo_link" href={`${ROUTES.ADDITIONAL_INFO}aviso-de-privacidad`}>Aviso de privacidad</a>
      <a className="AditionalInfo_link" href={`${ROUTES.ADDITIONAL_INFO}politicas-de-cookies`}>Políticas de cookies</a>
      {/* <a href="">Aviso de Privacidad</a>
      <a href="">Políticas de cancelación</a>
      <a href="">Preguntas Frecuentes</a> */}
    </div>
  );
}

export default AditionalInfo;
